function getMobileMenuElement() {
  return document.getElementById("mobile-menu");
}

function openMobileMenu() {
  const headerHeight = getHeaderHeight();

  const mobileMenu = getMobileMenuElement();
  mobileMenu.classList.remove("hidden");
  mobileMenu.classList.remove("hide-effects");

  mobileMenu.style.top = "" + headerHeight + "px";
}

function closeMobileMenu() {
  const mobileMenu = getMobileMenuElement();
  mobileMenu.classList.add("hide-effects");
  setTimeout(() => {
    mobileMenu.classList.add("hidden");
  }, 150);
}

function toggleMobileMenu() {
  const mobileMenu = getMobileMenuElement();
  if (mobileMenu.classList.contains("hidden")) {
    openMobileMenu();
  } else {
    closeMobileMenu();
  }
}
